// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__2-TkJ","logoTitle":"Logo_logoTitle__6Wiv5"};